export default "__VITE_ASSET__MzX7ALrE__"